// extracted by mini-css-extract-plugin
module.exports = {"wrap":"style_wrap__2V19M","rotate":"style_rotate__3AfCr","rotateBack":"style_rotateBack__3TQgP"};